let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cc9Sw")).then(() => parcelRequire('6r3eq'));